// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { showModal } from '../redux/main/actions/modal';

type OwnProps = {
  listingId: string,
  listingType: string,
  render: ({
    flagListing: () => void
  }) => React.Node
};

type Props = {
  ...$Exact<OwnProps>,
  showModal: typeof showModal
};

type State = {
  flagged: boolean
};

class FlagListingContainer extends React.PureComponent<Props, State> {
  state = {
    flagged: false
  };

  showFlagListingModal = () => {
    const { listingId, listingType } = this.props;
    this.props.showModal('FLAG_LISTING', {
      listingId,
      listingType,
      onFlagged: () => {
        this.setState({ flagged: true });
      }
    });
  };

  render() {
    if (this.state.flagged) {
      return null;
    }
    return this.props.render({ flagListing: this.showFlagListingModal });
  }
}

export default connect<Props, OwnProps, _, _, _, _>(
  null,
  { showModal }
)(FlagListingContainer);
